import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-assessors-start',
  templateUrl: 'assessors-start.component.html',
  styleUrls: ['./assessors-start.component.less', '../../../shared/common.less'],
})

export class AssessorsStartComponent implements OnInit {
  @Input() isValidated: boolean = false;
  @Input() isTestVoteOpen: boolean = false;

  @Output() inviteAssessorsEvent = new EventEmitter();
  
  ngOnInit(): void {
  }
}
